import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@bonusly/design-system';
import { useDispatch } from '@bonusly/events';
import { UserDetailEntity } from '@bonusly/user-entities';

import { HandIcon } from '../assets/hand-icon';

interface UserPopoverActionsProps {
	user: UserDetailEntity;
}

export const UserPopoverActions: FC<UserPopoverActionsProps> = ({ user }) => {
	const { t } = useTranslation('components');
	const dispatch = useDispatch();

	const handleClickGive = () => {
		dispatch('init-give-recognition', {
			user: {
				id: user.id,
				displayName: user.displayName,
				imageSrc: user.profilePic,
				username: user.username,
			},
		});
	};

	return (
		<Button test-dataid="user-popover-recognition-button" backgroundColor="primary.bg" textTransform="capitalize" onClick={handleClickGive}>
			{t('user_popover.recognize')}&nbsp;
			<HandIcon />
		</Button>
	);
};
